import * as Yup from 'yup'

/**
 * `min (6)` sozinho deixava passar string vazia — o Yup só aplica `min` a valor presente,
 * e sem `required` o campo em branco é válido. O `matches` fecha o formato: o código do
 * servidor é sempre 6 dígitos, inclusive com zeros à esquerda.
 */
const verificationCodeValidator = Yup.object ({
  verification_code: Yup
    .string ()
    .required ('Insira o código de 6 dígitos')
    .matches (/^\d{6}$/, 'O código deve ter 6 dígitos')
})

export default verificationCodeValidator
